export const ONLINE_COURSE_LAYOUTS = ["classic", "hub-v1", "current"] as const;

export type OnlineCourseLayout = (typeof ONLINE_COURSE_LAYOUTS)[number];

export const DEFAULT_ONLINE_COURSE_LAYOUT: OnlineCourseLayout = "current";

export function isOnlineCourseLayout(
  value: string | undefined | null,
): value is OnlineCourseLayout {
  return (
    typeof value === "string" &&
    ONLINE_COURSE_LAYOUTS.includes(value as OnlineCourseLayout)
  );
}

/**
 * Deploy-time storefront layout for /courses/elearning/*.
 * Set NEXT_PUBLIC_ONLINE_COURSE_LAYOUT to classic | hub-v1 | current.
 * Unset or invalid values fall back to current.
 */
export function getOnlineCourseLayout(
  raw: string | undefined | null = process.env.NEXT_PUBLIC_ONLINE_COURSE_LAYOUT,
): OnlineCourseLayout {
  const normalised = raw?.trim().toLowerCase();
  if (isOnlineCourseLayout(normalised)) {
    return normalised;
  }
  return DEFAULT_ONLINE_COURSE_LAYOUT;
}
